<template>
  <div>
    <v-container fluid class="pt-3">
      <vue-headful :title="`ข้อมูลธุรกิจ - Halalize for Business`" />

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/company' }">ข้อมูลธุรกิจ</el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>

      <section class="mt-4">
        <el-tabs :tab-position="`top`">
          <el-tab-pane label="ข้อมูลทั่วไป">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card mb-4">
                  <div>
                    <h3>แพ็กเกจ</h3>
                  </div>
                  <div>โปร &middot; หมดอายุวันที่</div>
                </el-card>

                <el-card class="box-card mb-4">
                  <div>
                    <h3>การใช้งาน</h3>
                    <p>สถิติการใข้งานบริการ 3rd party</p>
                  </div>
                  <div class="mb-5">
                    <label>การส่ง SMS</label>
                    <el-progress :percentage="100"></el-progress>
                  </div>
                  <div class="mb-5">
                    <label>การเรียกใช้งาน Google Map API</label>
                    <el-progress :percentage="60"></el-progress>
                  </div>
                </el-card>

                <el-card class="box-card">
                  <div>
                    <h3>ข้อมูลธุรกิจ</h3>
                    <p>ข้อมูลพื้นฐานเกี่ยวกับธุรกิจของคุณ</p>
                  </div>
                  <el-form label-position="left" label-width="100px">
                    <el-form-item label="ชื่อธุรกิจ">
                      <el-input v-model="info_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="ที่อยู่">
                      <el-input type="textarea" v-model="info_form.address"></el-input>
                    </el-form-item>
                  </el-form>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
          <el-tab-pane label="ตั้งค่าการเงิน">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card">
                  <div>
                    <h3>บัญชีธนาคาร</h3>
                    <p>ข้อมูลบัญชีธนาคารสำหรับรับเงิน</p>
                  </div>
                  <el-form label-position="left" label-width="100px">
                    <el-form-item label="เลขที่บัญชี">
                      <el-input v-model="bank_form.find(x=>x.key=='number').value"></el-input>
                    </el-form-item>
                    <el-form-item label="ธนาคาร">
                      <el-input v-model="bank_form.find(x=>x.key=='bankcode').value"></el-input>
                    </el-form-item>
                    <el-form-item label="ชื่อบัญชี">
                      <el-input v-model="bank_form.find(x=>x.key=='name').value"></el-input>
                    </el-form-item>
                    <el-form-item label="สาขา">
                      <el-input v-model="bank_form.find(x=>x.key=='branch').value"></el-input>
                    </el-form-item>
                  </el-form>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
          <el-tab-pane label="การแจ้งเตือน">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card">
                  <el-form label-position="left" label-width="250px">
                    <h3 class="mb-4">การแจ้งเตือนทาง LINE Messaging</h3>
                    <el-form-item label="ส่ง LINE Messaging แจ้งชำระเงิน">
                      <el-radio v-model="notifications.line_paylink" label="2">ส่งทุกออเดอร์</el-radio>
                      <el-radio v-model="notifications.line_paylink" label="0">ไม่ต้องส่ง</el-radio>
                    </el-form-item>
                    <el-form-item label="ส่ง LINE Messaging ยืนยันออเดอร์">
                      <el-radio v-model="notifications.line_confirm" label="2">ส่งทุกออเดอร์</el-radio>
                      <el-radio v-model="notifications.line_confirm" label="0">ไม่ต้องส่ง</el-radio>
                    </el-form-item>

                    <v-divider class="mb-4"></v-divider>
                    <h3 class="mb-4">การแจ้งเตือนทาง Email</h3>
                    <el-form-item label="ส่ง Email แจ้งชำระเงิน">
                      <el-radio v-model="notifications.email_paylink" label="2">ส่งทุกออเดอร์</el-radio>
                      <el-radio
                        v-model="notifications.email_paylink"
                        label="1"
                      >ส่งเฉพาะลูกค้าที่ไม่มี LINE UserID</el-radio>
                      <el-radio
                        v-model="notifications.email_paylink"
                        :disabled="true"
                        label="0"
                      >ไม่ต้องส่ง</el-radio>
                    </el-form-item>
                    <el-form-item label="ส่ง Email ยืนยันออเดอร์">
                      <el-radio v-model="notifications.email_confirm" label="2">ส่งทุกออเดอร์</el-radio>
                      <el-radio
                        v-model="notifications.email_confirm"
                        label="1"
                      >ส่งเฉพาะลูกค้าที่ไม่มี LINE UserID</el-radio>
                      <el-radio
                        v-model="notifications.email_confirm"
                        :disabled="true"
                        label="0"
                      >ไม่ต้องส่ง</el-radio>
                    </el-form-item>
                    <v-divider class="mb-4"></v-divider>
                    <h3 class="mb-4">การแจ้งเตือนทาง SMS</h3>
                    <el-form-item label="ส่ง SMS แจ้งชำระเงิน">
                      <el-radio v-model="notifications.sms_paylink" label="2">ส่งทุกออเดอร์</el-radio>
                      <el-radio
                        v-model="notifications.sms_paylink"
                        label="1"
                      >ส่งเฉพาะลูกค้าที่ไม่มี LINE UserID</el-radio>
                      <el-radio v-model="notifications.sms_paylink" label="0">ไม่ต้องส่ง</el-radio>
                    </el-form-item>
                    <el-form-item label="ส่ง SMS ยืนยันออเดอร์">
                      <el-radio v-model="notifications.sms_confirm" label="2">ส่งทุกออเดอร์</el-radio>
                      <el-radio
                        v-model="notifications.sms_confirm"
                        label="1"
                      >ส่งเฉพาะลูกค้าที่ไม่มี LINE UserID</el-radio>
                      <el-radio v-model="notifications.sms_confirm" label="0">ไม่ต้องส่ง</el-radio>
                    </el-form-item>
                  </el-form>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
          <el-tab-pane label="ตั้งค่า LINE API (Pro)">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card">
                  <div>
                    <h3>LINE API</h3>
                    <p>เชื่อมต่อระบบเข้ากับ Line Official Account ของคุณโดยใส่ข้อมูลด้านล่างให้ครบถ้วน</p>
                  </div>
                  <el-form label-position="left" label-width="180px">
                    <el-form-item label="Line Secret Key">
                      <el-input type="password" v-model="info_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Line Access Token">
                      <el-input v-model="info_form.address"></el-input>
                    </el-form-item>
                  </el-form>
                </el-card>
              </v-flex>
              <v-flex xs12 md4 class="pl-3">
                <el-card class="box-card">
                  <div>
                    <h3>วิธีการเชื่อมต่อ</h3>
                    <p>เชื่อมต่อระบบเข้ากับ Line Official Account ของคุณโดยใส่ข้อมูลด้านล่างให้ครบถ้วน</p>
                  </div>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
        </el-tabs>
      </section>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    title: "",
    info_form: {
      name: "",
      address: ""
    },
    bank_form: [
      { key: "name", value: "Company B Co., Ltd." },
      { key: "number", value: "0105557160824" },
      { key: "bank", value: "promptpay" },
      { key: "bankcode", value: "promptpay" },
      { key: "branch", value: "" }
    ],
    notifications: [
      { email_paylink: 0, email_confirm: 0 },
      { line_paylink: 0, line_confirm: 0 },
      { sms_paylink: 0, sms_confirm: 0 }
    ],
    line: {
      secret: "",
      accestoken: ""
    }
  }),
  created() {
    let params = {
      begin: "2020-05-20",
      end: "2020-05-27",
      report: true,
      type: "view"
    };
  }
};
</script>
